import React from 'react';
import {useFormik} from 'formik';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';

export default function SendCodeToContact({user, handleSubmit}) {

	const formik = useFormik({
		initialValues: {
			method: user.email ? 'email' : 'text'
		},
		onSubmit: async (values) => {
			await handleSubmit(values.method)
		},
	});

	return (
			<Box component="form" onSubmit={formik.handleSubmit} sx={{ mt: 1 }}>
				<FormControl component="fieldset">
					<FormLabel component="legend">Select a method to receive verification code</FormLabel>
					<RadioGroup
						aria-label="method"
						defaultValue={user.email ? 'email' : 'text'}
						name="method"
						onChange={formik.handleChange}
					>
						{ user.email &&
							<FormControlLabel value="email" control={<Radio />} label={`Email:  ${user.email}`} />
						}
						{ user.phone &&
							<FormControlLabel value="text" control={<Radio />} label={`Text:  ${user.phone}`} />
						}
					</RadioGroup>
				</FormControl>
				<Button
					type="submit"
					fullWidth
					variant="contained"
					sx={{ mt: 3, mb: 2 }}
				>
					NEXT
				</Button>
			</Box>
	)

}